<template>
  <div id="container">
    <div id="login_bg">
      <div class="Login_left">
        <div class="Login_left_img"></div>
        <p>Card Hobby Seller Center</p>
      </div>
      <div id="LoginBox">
        <router-link class="el-icon-arrow-left back" :to="{path:'/login'}">{{ $t('button.back') }}</router-link>
        <div class="login_logo">
          <h1>{{ $t('login.setPassword') }}</h1>
        </div>
        <el-form class="register_box set_box" :model="ruleForm" :rules="rules" ref="setword">
          <div class="code_box">
            <el-form-item class="login_form_item" prop="email">
              <el-input class="login_ipt first_login_ipt" id="EMail" name="EMail" v-model="ruleForm.email" :placeholder="$t('login.emailText')">
              </el-input>
            </el-form-item>
            <el-form-item class="login_form_item" prop="code">
              <el-input class="login_ipt login_ipt_c" id="EMailCode" name="EMailCode" minlength='6' maxlength='6' v-model="ruleForm.code"
              :placeholder="$t('login.codeText')">
              </el-input>
              <div class="code text_blue" v-if="isCode" @click="getCode('setword')"><span>{{ $t('button.sentCode') }}</span></div>
              <div class="code text_gray" v-if="!isCode"><span>{{ $t('button.resend') }} {{ times }}s</span></div>
            </el-form-item>
            <el-form-item class="login_form_item" prop="password">
              <el-input class="login_ipt password_ipt login_ipt_m" id="Password" name="Password" :type="flagType" minlength='6'
                maxlength='20' v-model="ruleForm.password" @input="CheckVal('password')" :placeholder="$t('login.passwordText')">
                <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
              </el-input>
            </el-form-item>
          </div>
          <div class="forgot">
            {{ $t('login.passwordOverview') }}
          </div>
          <div class="show_check_email">
            <div class="check_email">
              <span v-if="CheckEmail">{{ $t('login.emailSent') }} {{ruleForm.email}}.</span>
            </div>
          </div>

          <el-button class="text_btn" type="primary" :disabled="disabled" @click="submitForm('setword')">{{ $t('button.resetPassword') }}</el-button>
          <!-- <div class="account_box">
            Don't have an account yet? <router-link class="text_blue" :to="{path:'/register'}">Sign up now</router-link>
          </div> -->
        </el-form>

        <!-- <div class="terms_checked">
          <el-checkbox  v-model="checkbox " :label="1">{{radioNumber}}</el-checkbox >
          <div>
            I have read and accept the <span class="text_blue">Terms of Service</span> and <router-link class="text_blue"
              :to="{path:'/terms/privacy'}">Privacy
              Policy</router-link>
          </div>
        </div>
        <div class="account_box">
          Don't have an account yet? <router-link class="text_blue" :to="{path:'/register'}">Sign up now</router-link>
        </div> -->
      </div>

    </div>
    <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px" style="margin-top: 25vh;">
      <div class="dialog_box">
        <div class="" style="margin:16px 0 10px">
          To proceed, please agree to the
          <a href="#" class="dialog_a">Terms of Service and PrivacyPolicy</a>
          .
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="isChecked">Agree</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
export default {
  name: 'index',
  components: {},
  data() {
    var passwordLeng = this.$t('login.passwordLeng');//密码长度错误提示
    var passwordRules = this.$t('login.passwordRules');//密码规则错误提示
    var wrong = this.$t('login.wrong');//邮箱或密码错误提示
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(wrong));
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    var email = () => {
      let str = this.$route.query.email;
      str = str.split('@');
      if (str[0].length <= 3) {
        str[0] = str[0].substr(0, 1)
      } else {
        str[0] = str[0].substr(0, 3)
      }
      return str[0] + "*********@" + str[1]
    }
    return {
      flagType: 'password',
      flag: false,
      dialogTitle: "",
      dialogVisible: false,
      CheckEmail: false,
      // email: email(),
      times: 60,
      disabled: false,
      isCode: true,
      ifshow: false,
      // checked: false,
      // radioNumber: '',
      // checkbox: false,
      ruleForm: {
        email: '',
        password: '',
        code: '',
      },
      rules: {
        email: [
          { required: true, message: this.$t('login.emailTip'), trigger: 'blur' },
          { type: 'email', message: this.$t('login.emailTip'), trigger: 'blur' },
          { validator: userValidate }
        ],
        password: [
          {
            required: true,
            validator: function (rule, value, callback) {
              var exg = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/;
              if (!value) {
                callback(new Error(passwordLeng));
              } else if (value.length < 6 || value.length > 20) {
                //长度：6-20位（含）
                callback(new Error(passwordLeng));
              } else if (!exg.test(value)) {
                //必须包含大小写字母，一个数字。可包含特殊字符如？！@#，不支持emoji
                callback(new Error(passwordRules));
              } else {
                // 验证通过
                callback();
              }
            }, trigger: 'blur'
          },
          // { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: 'Invalid password, please set again.', trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('login.codeTip'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('login.codeTip'), trigger: 'blur' }
        ],

      }
    }
  },
  created() {
    let str = this.$route.query.email;
    if (str != null) {
      this.ruleForm.email = str
    }
  },
  mounted() {
    // /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,}$/
  },
  methods: {
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
    },
    // isChecked() {
    //   this.dialogVisible = false
    //   this.radio = 1
    // },
    // dialog() {
    //   this.dialogVisible = true;
    //   this.dialogTitle = "Notice"
    // },

    //获取验证码
    getCode(formName) {
      var that = this;
      console.log(formName)
      this.$refs[formName].validateField('email', (val) => {
        if (val == "") {
          that.CheckEmail = true;
          that.isCode = false;
          var data = { 'email': this.ruleForm.email, "type": 0 }
          console.log(data)
          that.CheckEmail = true;
          that.isCode = false;

          that.timer = setInterval(() => {
            that.times--;
            if (that.times === 0) {
              that.times = 60;
              that.isCode = true;
              clearInterval(that.timer)
            }
          }, 1000)
          var data = { 'UserApi': 'UserApi', 'email': this.ruleForm.email, "type": 1 }
          console.log(data);
          that.$post('SendEmail', data)//向邮箱发送验证码
            .then((res) => {
              console.log("axios-res:", res);
              if (res.Result) {
                that.$message({
                  showClose: true,
                  message: 'Send Email Successful',
                  type: "success",
                });
              } else {
                this.disabled = false;
                let Msg = 'Send Email Failed';
                that.$message.error(Msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })



    },
    //修改密码
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = { 'UserApi': 'UserApi', 'email': this.ruleForm.email, 'newPassword': this.ruleForm.password, 'code': this.ruleForm.code }
          this.disabled = true;// 禁用
          this.$post('ResetPassword', data).then(res => {//邮箱重置密码
            console.log(res)
            if (res.Result != 0) {
              //window.localStorage.setItem("cardUser",JSON.stringify(res.Data))
              this.$message({
                message: 'Password reset successful',
                type: 'success'
              });
              setTimeout(function () { that.$router.push({ name: 'Login', }) }, 1000)
            } else {
              console.log(res.Msg)
              that.$message.error(res.Msg);
            }

            that.disabled = false;
          })
        }
      });
    },
    //输入框验证
    CheckVal(obj, type = '') {
      let that = this;
      if (obj) {
        let val = that.ruleForm[obj];
        that.$set(that.ruleForm, obj, val.replace(/\s+/g, ""));
      }
      if (this.ruleForm.password.length > 0) {
        this.ifshow = true
      } else {
        this.ifshow = false
      }
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";
</style>



// WEBPACK FOOTER //
// src/pages/shared/forgot.vue